import React from "react";

export const STATUS_META = {
  pass: { label: "Pass", cls: "ok" },
  fail: { label: "Fail", cls: "crit" },
  manual: { label: "Not assessed", cls: "manual" },
  na: { label: "N/A", cls: "na" },
  exception: { label: "Accepted risk", cls: "exception" },
  error: { label: "Not evaluated", cls: "error" },
};

export const StatusChip = ({ status, testId }) => {
  const m = STATUS_META[status] || { label: status, cls: "" };
  return (
    <span className={`cis-status ${m.cls}`} data-testid={testId}>
      {m.label}
    </span>
  );
};

/** Per-section compliance bars; clicking a section filters the control list. */
export default function SectionBars({ sections, active, onSelect }) {
  const visible = sections.filter((s) => s.in_scope > 0);
  return (
    <section className="ws-card glass" data-testid="cis-sections">
      <div className="ws-card-head">
        <h2>Compliance by section</h2>
        <span className="muted small">Click a section to filter the controls below.</span>
      </div>
      <ul className="cis-section-list">
        {visible.map((s) => {
          const denom = s.pass + s.fail;
          const pct = s.percent;
          return (
            <li key={s.id} className={`cis-section ${active === s.id ? "active" : ""}`} data-testid={`cis-section-${s.id}`}>
              <button type="button" onClick={() => onSelect(active === s.id ? "" : s.id)} aria-pressed={active === s.id}>
                <span className="cis-section-name">
                  <b className="mono">{s.id}</b> {s.name}
                </span>
                <span className="cis-section-bar" aria-hidden="true">
                  {denom > 0 && <span className="pass" style={{ width: `${(100 * s.pass) / s.in_scope}%` }} />}
                  {denom > 0 && <span className="fail" style={{ width: `${(100 * s.fail) / s.in_scope}%` }} />}
                  <span className="exception" style={{ width: `${(100 * s.exception) / s.in_scope}%` }} />
                  <span className="unassessed" style={{ width: `${(100 * s.unassessed) / s.in_scope}%` }} />
                </span>
                <span className="cis-section-pct mono">{pct === null ? "–" : `${pct}%`}</span>
                <span className="cis-section-counts muted small">
                  {s.pass} pass · {s.fail} fail{s.exception ? ` · ${s.exception} risk` : ""}
                  {s.unassessed ? ` · ${s.unassessed} open` : ""}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
